import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private authHeaders(token: string) {
    return { headers: { Authorization: `Bearer ${token}` } };
  }

  // sendOtp(username: string, location: { latitude: number, longitude: number }) {
  //   return this.http.post(`${this.baseUrl}/users/send-otp`, { username, location });
  // }

register(data: any) {
  return this.http.post(`${this.baseUrl}/users/register`, data);
}


  // verifyOtpRegister(data: any) {
  //   return this.http.post(`${this.baseUrl}/users/verify-otp-register`, data);
  // }

  getNearbyUsers(token: string, distance: number, page: number = 1, limit: number = 50, gender?: string) {
    let url = `${this.baseUrl}/users/nearby?distance=${distance}&page=${page}&limit=${limit}`;
    if (gender) url += `&gender=${encodeURIComponent(gender)}`;
    return this.http.get(url, this.authHeaders(token));
  }

  // sendForgotOtp(email: string) {
  //   return this.http.post(`${this.baseUrl}/users/forgot-password/send-otp`, { email });
  // }

  // verifyForgotOtp(email: string, otp: string) {
  //   return this.http.post(`${this.baseUrl}/users/forgot-password/verify-otp`, { email, otp });
  // }

  // resetPassword(email: string, newPassword: string) {
  //   return this.http.post(`${this.baseUrl}/users/forgot-password/reset-password`, { email, newPassword });
  // }

  login(username: string, password: string, location?: { latitude: number; longitude: number }) {
    const body: any = { username, password };
    if (location) body.location = location;
    return this.http.post(`${this.baseUrl}/users/login`, body);
  }

  deleteAccount(userId: string, token: string) {
    return this.http.delete(`${this.baseUrl}/users/${userId}`, this.authHeaders(token));
  }

  searchUsers(token: string, query: string) {
    return this.http.get(`${this.baseUrl}/users/search?query=${query}`, this.authHeaders(token));
  }

  getUserPreferences(token: string) {
    return this.http.get(`${this.baseUrl}/users/get-preferences`, this.authHeaders(token));
  }

fetchNotifications(token: string) {
  return this.http.get(`${this.baseUrl}/users/notifications`, this.authHeaders(token));
}

markNotificationsRead(token: string) {
  return this.http.post(`${this.baseUrl}/users/notifications/mark-read`, {}, this.authHeaders(token));
}

  likeUser(userId: string, token: string) {
    return this.http.post(`${this.baseUrl}/users/like/${userId}`, {}, this.authHeaders(token));
  }

  dislikeUser(userId: string, token: string) {
    return this.http.post(`${this.baseUrl}/users/dislike/${userId}`, {}, this.authHeaders(token));
  }

  getUserById(userId: string, token: string) {
  return this.http.get(`${this.baseUrl}/users/${userId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
}

  // Optional: Token management helpers
  setToken(token: string) {
    localStorage.setItem('auth_token', token);
  }

  getToken(): string | null {
    return localStorage.getItem('auth_token');
  }

  logout() {
    localStorage.removeItem('auth_token');
    // Optionally clear other user data
  }

  deleteReadNotifications(token: string) {
  return this.http.delete(`${this.baseUrl}/users/notifications/delete-read`, {
    headers: { Authorization: `Bearer ${token}` }
  });
}

}